




















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getLiveTime } from '../ts/common';
import HotTag from './HotTag.vue';
import { getLiveShop } from '../api/index';
Vue.use(List);
@Component({
  components: {
    HotTag,
  },
})
export default class DetailText extends Vue {
  public shopList: any[] = [];
  public loading: boolean = false;
  public finished: boolean = false;
  public page = 1;
  @Prop() public item!: any;
  @Prop() public createDate!: any;
  @Prop({ default: false }) public text!: boolean;
  @Prop({ default: false }) public live!: boolean;
  onLoad() {
    getLiveShop(this.$route.query.id, this.page).then((res) =>
      this.endLiveShop(res),
    );
  }
  endLiveShop(res: any) {
    if (res.data && res.data.length > 0) {
      this.page = this.page + 1;
      this.shopList = [...this.shopList, ...res.data];
    } else {
      this.finished = true;
    }
    this.loading = false;
  }
  enterShop(item: any) {
    window.location.href = item.url;
  }
}
